import Text from "@/components/Text";
import { FC, ComponentProps } from "react";
import styled from "styled-components";

const Button = styled.button`
  color: ${({ theme }) => theme.colors.black};
  border-radius: 50px;
  border: 0.5px solid transparent;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  height: 38px;
  transition: 0.2s ease-out all;

  svg {
    margin-right: 8px;
  }

  &:hover {
    border-color: rgba(34, 34, 34, 0.25);
  }
  &:active {
    border-color: ${({ theme }) => theme.colors.grayscaleLight};
    background: ${({ theme }) => theme.colors.grayscaleLight};
  }
`;

const AddButton: FC<ComponentProps<typeof Button>> = ({
  children,
  ...rest
}) => {
  return (
    <Button {...rest}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2V14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 8H14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Text as="span" $type="caption">
        {children}
      </Text>
    </Button>
  );
};

export default AddButton;
